import * as urlUtils from 'utils/Url';


export function getPathOnVoardResources(qs={}) {
  return urlUtils.appendQueryString(`/onvoard-resources`, qs);
}

export function getPathExternalResources(qs={}) {
  return urlUtils.appendQueryString(`/external-resources`, qs);
}

export function getPathCustomResources(qs={}) {
  return urlUtils.appendQueryString(`/custom-resources`, qs);
}

export function getPathPredefinedResourceAssociations(qs={}) {
  return urlUtils.appendQueryString(`/predefined-resource-associations`, qs);
}

export function getPathCustomResourceAssociations(qs={}) {
  return urlUtils.appendQueryString(`/custom-resource-associations`, qs);
}

export function getPathResourceAssociationRecords(associationKey, qs={}) {
  return urlUtils.appendQueryString(`/resource-associations/${associationKey}/records`, qs);
}

export function getPathResourceProperties(accessor, qs={}) {
  return urlUtils.appendQueryString(`/resources/${accessor}/properties`, qs);
}

export function getPathResourceRecords(accessor, qs={}) {
  return urlUtils.appendQueryString(`/resources/${accessor}/records`, qs);
}

